import Footer from "./COMPONENTS/Footer";
import Header from "./COMPONENTS/Header";


function App() {
  return (
    <>
      <Header />
   

      <Footer />
    </>
  );
}

export default App;
